import type { RouteLocationNormalized } from 'vue-router'
import { RoutingDefinitions } from '@generator/types/RoutingDefinitions'
import { PortalType } from '@studyportals/domain-client'

export const isCatchAllRoute = (to: RouteLocationNormalized): boolean => {
	if (to.matched.length === 0) return true;

	return to.matched.some((record) => {
		return record.name === RoutingDefinitions.CATCH_ALL;
	});
};

export const DEFAULT_PORTAL_TYPE = PortalType.MASTER;
